.root {
  color: var(--color-ds-content-subtle);
  outline-offset: var(--outline-ds-offset-focus);
}

.root:hover {
  color: var(--color-ds-content-subtle-hover);
}

.root:focus-visible {
  outline-color: var(--color-ds-border-focus);
  outline-width: var(--outline-ds-width-focus);
}
